import React from 'react';
import spinner from '../../static/images/spinner.svg';

const Spinner = ({ type }) => {
  let className = '';
  if (type === 'moreButton') {
    className = 'more-spinner-crop';
  } else if (type === 'library') {
    className = 'spinner-crop library-spinner';
  } else if (type === 'regular') {
    className = 'spinner-crop';
  }
  return (
    <div className={className}>
      <img
        className="spinner"
        viewBox="0 0 100 100"
        src={spinner}
        alt="spinner"
      />
    </div>
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/comps/Spinner/Spinner.js